class CarModel {
  readonly createdOn: string;
  readonly brand: string;
  readonly model:string;
  readonly id:number;
  readonly userId:string;
  readonly verificationStatus:string;
  readonly image:string;
  readonly fio: string;
  constructor({
    createdOn,
    brand,
    model,
    id,
    userId,
    verificationStatus,
    image,
    fio,
  }) {
    this.createdOn = createdOn;
    this.brand = brand;
    this.model = model;
    this.id=id;
    this.userId=userId;
    this.verificationStatus=verificationStatus;
    this.image=image;
    this.fio=fio;
  }
}

export default CarModel;
